import { Item } from '@/features/cart/types'

export function computeEligibleItemsTotal(
  items: readonly Item[],
  eligibleCollections: readonly string[] = [],
): number {
  const totalValue = items.reduce((accumulator, item) => {
    const isEligible =
      eligibleCollections.some((collection) =>
        item.collections.includes(collection),
      ) || eligibleCollections.length === 0

    if (isEligible) {
      return accumulator + item.finalLinePrice
    }

    return accumulator
  }, 0)

  return totalValue / 100
}
